/* eslint-disable react/jsx-props-no-spreading */
import { SVGProps } from 'react';

const ValidationCorrect = (props: SVGProps<SVGSVGElement>) => (
  <svg width={18} height={18} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx={9} cy={9} r={9} fill="#00BD84" />
    <path
      d="m13.357 6.071-5.843 6.072-2.657-2.76"
      stroke="#fff"
      fill="none"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ValidationCorrect;
